module.exports = __webpack_public_path__ + "img/zuja-2.607203c5.jpg";